export const appName = 'WeLoveNight'
export const sendingEmail = 'hello@welovenight.com'
